import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import HCBoost from "highcharts/modules/boost";
import HCDataGrouping from "highcharts/modules/data";
import React, { useEffect, useState } from "react";
import { useAuthContext } from "../../../context/AuthProvider";
import HighchartsMore from "highcharts/highcharts-more";
import zIndex from "@mui/material/styles/zIndex";

// Initialize data grouping module
HCDataGrouping(Highcharts);
HCBoost(Highcharts);
HighchartsMore(Highcharts);

const BoxPlot = ({
  actual = [[760, 801, 848, 895, 965]],
  categories = ["Paternoster Humidity"],
  TheoreticalMean = 932,
  factorName = "Paternoster Humidity",
}) => {
  const [state, setState] = useState(null);
  const { QCFull } = useAuthContext();

  const timezoneOffset = new Date().getTimezoneOffset();
  useEffect(() => {
    setState({
      chart: {
        type: "boxplot",
        zoomType: "x",
        height: QCFull
          ? window.screen.height - window.screen.height / 3
          : window.screen.height - window.screen.height / 2.1 || "450px",
      },
      title: {
        text: `Box Plot of ${factorName}`,
        align: "center",
        floating: false,
        margin: 15,
        style: {
          color: "#404040",
          fontSize: "15px",
          fontWeight: "500",
          fontFamily: "Montserrat, sans-serif",
        },
        useHTML: false,
        verticalAlign: undefined,
        widthAdjust: -44,
      },
      series: [
        {
          data: actual,
          name: "Variable",
          //   color: "#EA8600",
        },
      ],
      legend: {
        enabled: false,
      },
      boost: {
        seriesThreshold: 100000,
      },
      credits: {
        enabled: false,
      },
      time: {
        timezoneOffset: timezoneOffset,
      },
      xAxis: {
        categories: categories,
        title: {
          enabled: false,
        },
        crosshair: {
          width: 1,
          color: "#e4e4e4",
          dashStyle: "Solid",
        },
        labels: {
          style: {
            color: "#404040",
            fontSize: "10px",
            fontWeight: "600",
          },
        },
      },
      yAxis: {
        title: {
          text: factorName,
        },
        labels: {
          format: "{text}",
          style: {
            color: "#404040",
            fontSize: "10px",
            fontWeight: "600",
          },
        },
        plotLines: [
          {
            value: TheoreticalMean,
            color: "red",
            width: 1,
            zIndex: "99999",
            label: {
              text: `Theoretical mean: ${TheoreticalMean}`,
              align: "center",
              style: {
                color: "gray",
              },
            },
          },
        ],
      },
    });
  }, [window.screen.height, QCFull]);

  if (!actual) {
    return null; // or render a loading indicator
  }

  return (
    <div id="chart" style={{ borderRadius: "16px" }}>
      <HighchartsReact highcharts={Highcharts} options={state} />
    </div>
  );
};
export default BoxPlot;
